import axiosHttp from "../hooks/intercepter";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Stock Purchase Report
export const getStockPurchaseReport = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.groceryId) queryParams.append('groceryId', params.groceryId);
  
  const queryString = queryParams.toString();
  const url = `${BASE_URL}/stock-reports/purchase${queryString ? `?${queryString}` : ''}`;
  
  return await axiosHttp.get(url);
};

// Stock Used Report
export const getStockUsedReport = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.groceryId) queryParams.append('groceryId', params.groceryId);
  
  const queryString = queryParams.toString();
  const url = `${BASE_URL}/stock-reports/used${queryString ? `?${queryString}` : ''}`;
  
  return await axiosHttp.get(url);
};

// Price Report
export const getPriceReport = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.groceryId) queryParams.append('groceryId', params.groceryId);
  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
  
  const queryString = queryParams.toString();
  const url = `${BASE_URL}/stock-reports/price${queryString ? `?${queryString}` : ''}`;
  
  return await axiosHttp.get(url);
};

// Comprehensive Stock Report
export const getComprehensiveStockReport = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);
  if (params.groceryId) queryParams.append('groceryId', params.groceryId);
  
  const queryString = queryParams.toString();
  const url = `${BASE_URL}/stock-reports/comprehensive${queryString ? `?${queryString}` : ''}`;
  
  return await axiosHttp.get(url);
};

// Get all groceries for filter dropdown
export const getAllGroceries = async () => {
  return await axiosHttp.get(`${BASE_URL}/grocery`);
};
